module.exports = __webpack_public_path__ + "img/lte.5967b3ce.svg";